import { EntDirectoryInfoName } from '../directoryInfoName'

export class EntProduct {
	id: number | null = null
	nameKy: string | null = null
	nameRu: string | null = null
	parent: { id: number; childId?: number | null } | null = null
	category?: {
		id: number
		nameRu: string | null
		nameKy: string | null
		parent: any | null
		parentId: number | null
		children: any | null
	} | null = null
	varieties?: Array<{
		id: number | null
		nameKy: string | null
		nameRu: string | null
	}> | null = null
	categoryId?: number | null = null
}

export class EntProductCompany {
	companyName: string | null = null
	id: number | null = null
}
